import eventDiscountService from "@/api/eventModule/eventDiscountServices";

export default {
  loadTable({ commit }, pageConfig) {
    return new Promise((resolve, reject) =>
      eventDiscountService
        .loadTable(pageConfig)
        .then((result) => {
          commit("LOAD_LIST_EVENT_DISCOUNT", result.data.content);
          resolve(result);
        })
        .catch((err) => reject(err))
    );
  },
  insertNew({ commit }, data) {
    return eventDiscountService
      .insertNew(data)
      .then((result) => result)
      .catch((error) => error);
  },
  prepareToEdit({ commit }, data) {
    commit("PREPARE_TO_EDIT_EVENT_DISCOUNT", data);
  },
  edit({ commit }, data) {
    return eventDiscountService
      .edit(data)
      .then((result) => result)
      .catch((error) => error);
  },
  reset({ commit }) {
    commit("RESET_EVENT_DISCOUNT");
  },
  delete({ commit }, id) {
    return eventDiscountService
      .delete(id)
      .then((result) => result)
      .catch((error) => error);
  },
};
